
import Shop from "../../../assets/filled/Shop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShopIcon({ className, dataTestid = "ShopIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Shop data-testid={dataTestid} className={classes} {...rest} />
  );
}
